{
  "dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "jira-issueview-layouts.issue-view-layout-picker-changeboarding-body": [
    {
      "type": 0,
      "value": "Choose a layout that works best for you."
    }
  ],
  "jira-issueview-layouts.issue-view-layout-picker-changeboarding-heading": [
    {
      "type": 0,
      "value": "Customise your view"
    }
  ],
  "jira-thor.jira-notifications-project-recap.issue-row.work-item-key": [
    {
      "type": 1,
      "value": "workItemKey"
    }
  ],
  "jira-thor.jira-notifications-project-recap.issue-row.work-item-summary": [
    {
      "type": 1,
      "value": "workItemSummary"
    }
  ],
  "jira-thor.jira-notifications-project-recap.message-template-template.email.body": [
    {
      "type": 0,
      "value": "Don't let this work slip under the radar. Keep an eye on these unassigned work items by watching them, or assign them to yourself."
    }
  ],
  "jira-thor.jira-notifications-project-recap.message-template-template.email.heading": [
    {
      "type": 0,
      "value": "This work hasn't been assigned to anyone"
    }
  ],
  "jira-thor.jira-notifications-project-recap.message-template-template.email.manage-notifications": [
    {
      "type": 0,
      "value": "Manage notifications"
    }
  ],
  "jira-thor.jira-notifications-project-recap.message-template-template.email.privacy-policy": [
    {
      "type": 0,
      "value": "Privacy policy"
    }
  ],
  "jira-thor.jira-notifications-project-recap.message-template-template.email.separator-dot": [
    {
      "type": 0,
      "value": "•"
    }
  ],
  "jira-thor.jira-notifications-project-recap.message-template-template.issue.assign.action": [
    {
      "type": 0,
      "value": "Assign to me"
    }
  ],
  "jira-thor.jira-notifications-project-recap.message-template-template.issue.watch.action": [
    {
      "type": 0,
      "value": "Watch"
    }
  ],
  "jira-thor.jira-notifications-project-recap.message-template-template.project.remaining.items": [
    {
      "type": 0,
      "value": "+"
    },
    {
      "type": 1,
      "value": "remaining"
    },
    {
      "type": 0,
      "value": " more..."
    }
  ],
  "jira-thor.jira-notifications-project-recap.message-template-template.project.total.unassigned.items": [
    {
      "type": 0,
      "value": "Unassigned work items ("
    },
    {
      "type": 1,
      "value": "totalCount"
    },
    {
      "type": 0,
      "value": ")"
    }
  ],
  "jira-thor.jira-notifications-project-recap.message-template-template.project.view.all": [
    {
      "type": 0,
      "value": "View all in Jira"
    }
  ],
  "jira-thor.jira-notifications-project-recap.message-template.email.subject.no-translate": [
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ", don't miss this week's unassigned work items"
    }
  ],
  "jira.jira-notifications-project-recap.message-template-template.email.contact-us": [
    {
      "type": 0,
      "value": "Contact us"
    }
  ],
  "jira.jira-notifications-project-recap.message-template-template.email.copyright": [
    {
      "type": 0,
      "value": "Copyright "
    },
    {
      "type": 1,
      "value": "year"
    },
    {
      "type": 0,
      "value": " Atlassian Pty Ltd. All rights reserved."
    }
  ],
  "jira.jira-notifications-project-recap.message-template-template.email.office-address": [
    {
      "type": 0,
      "value": "341 George Street, Sydney, NSW, 2000, Australia"
    }
  ],
  "try-now": [
    {
      "type": 0,
      "value": "Try now"
    }
  ]
}